<template>
  <v-app-bar
    :color="background"
    height="auto"
    class="mt-5 px-0 mx-6 border-radius-xl toolbar-content-padding-y-none"
    :class="
      navbarFixed
        ? 'position-sticky blur shadow-blur top-1 z-index-sticky py-2'
        : ''
    "
    flat
  >
    <v-row class="py-1 px-0">
      <v-col cols="12" sm="4" class="d-flex px-0">
        <v-list-item class="pa-0" v-if="$vuetify.breakpoint.mobile">
          <v-list-item-content class="pa-0">
            <v-list-item-title class="title d-flex align-center mb-0 pa-0">
              <div class="v-navigation-drawer-brand pa-0 d-flex align-center">
                <v-img
                  src="@/assets/img/logo.png"
                  class="navbar-brand-img ms-3"
                  width="35"
                >
                </v-img>
                <span class="ms-2 font-weight-bold text-md">鑅陞人資管理</span>
              </div>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <div
          class="drawer-toggler py-5 cursor-pointer"
          :class="{ active: togglerActive }"
          @click="minifyDrawer"
          v-if="!$vuetify.breakpoint.mobile"
        >
          <div class="drawer-toggler-inner">
            <i class="drawer-toggler-line bg-body"></i>
            <i class="drawer-toggler-line bg-body"></i>
            <i class="drawer-toggler-line bg-body"></i>
          </div>
        </div>
      </v-col>
      <v-col cols="12" sm="8" class="d-flex align-center px-0">
        <v-row no-gutters class="align-center w-100" justify="end">
          <v-col
            cols="6"
            sm="auto"
            class="d-flex align-center px-1"
            v-if="userRole === 'consultant' || userRole === 'superadmin'"
          >
            <v-select
              :value="selectedCompany"
              :items="companies"
              item-text="company_name"
              item-value="id"
              return-object
              hide-details
              class="
                input-style
                font-size-input
                text-light-input
                placeholder-light
                w-100
              "
              dense
              flat
              filled
              solo
              height="43"
              placeholder="選擇公司"
              @change="onCompanyChange"
            >
              <template slot="prepend-inner">
                <v-icon color="#adb5bd" size=".875rem">fas fa-building</v-icon>
              </template>
            </v-select>
          </v-col>
          <v-col
            :cols="
              userRole === 'consultant' || userRole === 'superadmin' ? 6 : 12
            "
            sm="auto"
            class="d-flex align-center justify-end px-1"
          >
            <v-btn
              depressed
              :ripple="false"
              class="font-weight-600 text-body ls-0 text-capitalize pe-0 me-2"
              color="transparent"
              :to="isAuthenticated ? null : '/pages/authentication/login'"
              @click="isAuthenticated && logout()"
            >
              <v-icon size="20">fa fa-user me-sm-2</v-icon>
              <span
                class="d-sm-inline font-weight-bold d-none"
                :class="{ 'btn-dark-hover': !hasBg, 'btn-hover': hasBg }"
                :style="!hasBg ? 'color: rgba(0,0,0, .6)' : ''"
                >{{ isAuthenticated ? "登出" : "登入" }}</span
              >
            </v-btn>

            <v-btn
              elevation="0"
              :ripple="false"
              height="43"
              class="
                font-weight-600
                text-capitalize
                drawer-toggler
                py-3
                px-0
                rounded-sm
              "
              :class="{
                'btn-dark-toggler-hover': !hasBg,
                'btn-toggler-hover': hasBg,
                active: togglerActive,
              }"
              v-if="$vuetify.breakpoint.mobile"
              color="transparent"
              @click="drawerClose"
            >
              <div class="drawer-toggler-inner">
                <i class="drawer-toggler-line text-body"></i>
                <i class="drawer-toggler-line text-body"></i>
                <i class="drawer-toggler-line text-body"></i>
              </div>
            </v-btn>

            <v-menu
              transition="slide-y-transition"
              offset-y
              offset-x
              min-width="300"
              max-width="300"
              :close-on-content-click="false"
            >
              <template v-slot:activator="{ on, attrs }">
                <div
                  class="
                    notification-bell-wrapper
                    position-relative
                    d-inline-flex
                  "
                >
                  <v-btn
                    icon
                    :ripple="false"
                    :class="{ 'btn-dark-hover': !hasBg, 'btn-hover': hasBg }"
                    class="text-body"
                    :color="linkColor"
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon
                      size="20"
                      :color="unreadReminderCount > 0 ? 'red' : linkColor"
                      :class="{
                        'notification-bell-icon-shake': unreadReminderCount > 0,
                      }"
                    >
                      fa fa-bell
                    </v-icon>
                  </v-btn>

                  <span
                    v-if="unreadReminderCount > 0"
                    class="notification-badge"
                  >
                    {{ displayUnreadReminderCount }}
                  </span>
                </div>
              </template>

              <v-list
                class="py-0 notification-list"
                style="max-height: 420px; overflow-y: auto"
              >
                <template v-if="recentNotifications.length > 0">
                  <v-list-item
                    v-for="item in recentNotifications"
                    :key="item.id"
                    class="pa-4 list-item-hover-active notification-item"
                    @click="openReminder(item)"
                  >
                    <v-list-item-avatar
                      :size="36"
                      class="my-0 me-4 border-radius-lg"
                      :class="`bg-gradient-${getReminderColor(item)}`"
                    >
                      <v-icon color="white" size="18">
                        {{ getReminderIcon(item) }}
                      </v-icon>
                    </v-list-item-avatar>

                    <v-list-item-content class="pa-0">
                      <v-list-item-title
                        class="text-body-2 ls-0 text-typo font-weight-600 mb-0"
                      >
                        <div class="d-flex align-center justify-space-between">
                          <span class="text-sm font-weight-bold text-typo">
                            {{ item.title }}
                          </span>
                          <v-chip
                            v-if="!item.read"
                            x-small
                            color="error"
                            text-color="white"
                            class="ms-2"
                          >
                            未讀
                          </v-chip>
                        </div>
                      </v-list-item-title>

                      <p class="text-sm text-typo mb-1">
                        {{ item.message }}
                      </p>
                      <p class="text-xs text-secondary mb-0">
                        <v-icon size="12" class="text-secondary"
                          >fa fa-clock me-1</v-icon
                        >
                        {{ formatReminderTime(item.timestamp) }}
                      </p>
                    </v-list-item-content>
                  </v-list-item>

                  <v-divider />

                  <v-list-item
                    v-if="hasMoreUnreadReminders"
                    :disabled="loadingUnreadNotifications"
                    class="pa-4 list-item-hover-active"
                    @click.stop="loadMoreUnreadNotifications"
                  >
                    <v-list-item-content class="pa-0 text-center">
                      <v-list-item-title
                        class="text-body-2 text-typo font-weight-600 mb-0"
                      >
                        <v-progress-circular
                          v-if="loadingUnreadNotifications"
                          indeterminate
                          size="16"
                          width="2"
                          color="primary"
                          class="me-2"
                        />
                        {{
                          loadingUnreadNotifications ? "載入中..." : "載入更多"
                        }}
                      </v-list-item-title>
                      <p class="text-xs text-secondary mb-0">
                        查看下一頁未讀提醒
                      </p>
                    </v-list-item-content>
                  </v-list-item>

                  <v-list-item
                    v-if="hasMoreUnreadReminders"
                    :disabled="
                      loadingUnreadNotifications ||
                      markingAllUnreadNotifications
                    "
                    class="pa-4 list-item-hover-active"
                    @click.stop="markAllUnreadNotificationsAsRead"
                  >
                    <v-list-item-content class="pa-0 text-center">
                      <v-list-item-title
                        class="text-body-2 text-typo font-weight-600 mb-0"
                      >
                        <v-progress-circular
                          v-if="markingAllUnreadNotifications"
                          indeterminate
                          size="16"
                          width="2"
                          color="primary"
                          class="me-2"
                        />
                        {{
                          markingAllUnreadNotifications
                            ? "處理中..."
                            : "標示全部已讀"
                        }}
                      </v-list-item-title>
                      <p class="text-xs text-secondary mb-0">
                        將所有未讀提醒標示為已讀
                      </p>
                    </v-list-item-content>
                  </v-list-item>
                </template>

                <v-list-item v-else class="pa-4">
                  <v-list-item-content class="pa-0">
                    <v-list-item-title
                      class="text-body-2 ls-0 text-typo font-weight-600 mb-0"
                    >
                      目前沒有提醒
                    </v-list-item-title>
                    <p class="text-xs text-secondary mb-0">
                      當有新的申請單訊息時，會即時顯示在這裡
                    </p>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-menu>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  icon
                  :ripple="false"
                  :class="{ 'btn-dark-hover': !hasBg, 'btn-hover': hasBg }"
                  class="text-body ml-2"
                  :color="linkColor"
                  to="/pages/users/profile"
                >
                  <v-icon size="20">fa fa-cog</v-icon>
                </v-btn>
              </template>
              <span>我的資料</span>
            </v-tooltip>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <progress-dialog :visible="showLogoutProgress" message="正在登出..." />
  </v-app-bar>
</template>
<script>
import { mapGetters } from "vuex";
import ProgressDialog from "@/components/Common/ProgressDialog.vue";
import websocketService from "@/utils/websocketService";

export default {
  name: "app-bar",
  components: {
    ProgressDialog,
  },
  props: {
    background: String,
    hasBg: Boolean,
    linkColor: String,
    toggleActive: Boolean,
    navbarFixed: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showLogoutProgress: false,
      drawer: false,
      togglerActive: false,
      recentNotifications: [],
      notificationLimit: 5,
      totalUnreadReminderCount: 0,
      reminderPagination: {
        currentPage: 1,
        pageSize: 5,
        totalItems: 0,
        totalPages: 0,
        hasNextPage: false,
        nextPage: null,
        prevPage: null,
      },
      loadingUnreadNotifications: false,
      markingAllUnreadNotifications: false,
      websocketReconnectTimer: null,
      websocketHandlerRegistered: false,
    };
  },
  computed: {
    ...mapGetters("company", ["companies", "selectedCompany"]),
    ...mapGetters("user", ["userCompanyId", "isAuthenticated"]),
    ...mapGetters({ userRole: "user/userRole" }),
    ...mapGetters({ websocketConnected: "websocket/isConnected" }),
    unreadReminderCount() {
      const paginationTotal = Number(this.reminderPagination?.totalItems);
      if (Number.isFinite(paginationTotal)) {
        return Math.max(0, paginationTotal);
      }

      if (Number.isFinite(this.totalUnreadReminderCount)) {
        return Math.max(0, this.totalUnreadReminderCount);
      }

      return this.recentNotifications.filter(
        (notification) => !notification.read
      ).length;
    },
    displayUnreadReminderCount() {
      const count = this.unreadReminderCount;
      return count > 99 ? "99+" : String(count);
    },
    hasMoreUnreadReminders() {
      return Boolean(this.reminderPagination?.hasNextPage);
    },
  },
  async mounted() {
    try {
      await this.initializeCompanies();
      await this.loadUnreadNotifications({ reset: true });
      this.registerReminderHandler();
      if (this.isAuthenticated) {
        await this.ensureWebsocketConnection();
      }
    } catch (error) {
      console.error("Error in AppBar mounted:", error);
    }
  },
  watch: {
    // Watch for changes in companies array
    companies: {
      immediate: true,
      handler(newCompanies) {
        if (newCompanies && newCompanies.length > 0 && !this.selectedCompany) {
          this.setDefaultCompany();
        }
      },
    },
    toggleActive(val) {
      this.togglerActive = val;
    },
    isAuthenticated: {
      immediate: true,
      handler(isAuthenticated, oldValue) {
        if (isAuthenticated) {
          if (oldValue !== undefined) {
            this.loadUnreadNotifications({ reset: true });
          }
          this.registerReminderHandler();
          this.ensureWebsocketConnection();
        } else {
          this.clearReminderReconnect();
          this.recentNotifications = [];
          this.$store.dispatch("websocket/clearNotifications");
        }
      },
    },
    websocketConnected(isConnected) {
      if (isConnected) {
        this.clearReminderReconnect();
      } else if (this.isAuthenticated) {
        this.scheduleReminderReconnect();
      }
    },
  },
  methods: {
    async ensureWebsocketConnection() {
      if (!this.isAuthenticated) return;
      try {
        await websocketService.connect();
      } catch (error) {
        console.error("WebSocket connection failed in AppBar:", error);
        this.scheduleReminderReconnect();
      }
    },
    scheduleReminderReconnect() {
      if (this.websocketReconnectTimer) {
        clearTimeout(this.websocketReconnectTimer);
      }

      this.websocketReconnectTimer = setTimeout(() => {
        this.websocketReconnectTimer = null;
        if (this.isAuthenticated) {
          this.ensureWebsocketConnection();
        }
      }, 5000);
    },
    clearReminderReconnect() {
      if (this.websocketReconnectTimer) {
        clearTimeout(this.websocketReconnectTimer);
        this.websocketReconnectTimer = null;
      }
    },
    registerReminderHandler() {
      if (this.websocketHandlerRegistered) return;
      websocketService.registerMessageHandler(
        "notification",
        this.handleReminderMessage
      );
      this.websocketHandlerRegistered = true;
    },
    unregisterReminderHandler() {
      if (!this.websocketHandlerRegistered) return;
      websocketService.unregisterMessageHandler(
        "notification",
        this.handleReminderMessage
      );
      this.websocketHandlerRegistered = false;
    },
    resetReminderState() {
      this.recentNotifications = [];
      this.totalUnreadReminderCount = 0;
      this.reminderPagination = {
        currentPage: 1,
        pageSize: this.notificationLimit,
        totalItems: 0,
        totalPages: 0,
        hasNextPage: false,
        nextPage: null,
        prevPage: null,
      };
    },
    async loadUnreadNotifications({ page = 1, reset = false } = {}) {
      if (!this.isAuthenticated) {
        return;
      }

      if (this.loadingUnreadNotifications) {
        return;
      }

      this.loadingUnreadNotifications = true;

      try {
        const response = await this.$axios.get("/api/messages/unread", {
          params: {
            page,
            limit: this.notificationLimit,
          },
        });

        const unreadMessages = response.data?.data || [];

        if (reset) {
          this.recentNotifications = [];
        }

        unreadMessages.forEach((message) => {
          this.mergeReminderNotification(
            this.normalizeBackendMessage(message),
            {
              adjustTotalUnreadCount: false,
            }
          );
        });

        const pagination = response.data?.pagination || {};
        const totalItems = Number.isFinite(pagination.totalItems)
          ? pagination.totalItems
          : Number.isFinite(response.data?.count)
          ? response.data.count
          : unreadMessages.length;

        this.totalUnreadReminderCount = totalItems;

        this.reminderPagination = {
          currentPage: pagination.currentPage || page,
          pageSize: pagination.pageSize || this.notificationLimit,
          totalItems,
          totalPages: pagination.totalPages || 0,
          hasNextPage: Boolean(pagination.hasNextPage),
          nextPage: pagination.nextPage || null,
          prevPage: pagination.prevPage || null,
        };
      } catch (error) {
        console.error("Failed to load unread reminders:", error);
      } finally {
        this.loadingUnreadNotifications = false;
      }
    },
    handleReminderMessage(message) {
      const payload = message?.payload || message;
      if (!payload || payload.type !== "reminder") {
        return;
      }

      this.mergeReminderNotification(this.normalizeReminder(payload));
    },
    normalizeReminder(payload) {
      const data = payload.data || {};
      const timestamp = payload.timestamp || new Date().toISOString();
      const id =
        data.message_id ||
        data.application_id ||
        data.id ||
        `${payload.type}-${timestamp}`;

      return {
        id,
        type: payload.type || "reminder",
        title: data.title || payload.title || payload.message || "提醒",
        message: payload.message || payload.content || data.message || "",
        timestamp,
        read: false,
        link: data.link || payload.link || data.url || null,
        data,
      };
    },
    normalizeBackendMessage(message) {
      const timestamp =
        message.create_time ||
        message.createdAt ||
        message.timestamp ||
        new Date().toISOString();

      return {
        id: message.id,
        type: "reminder",
        title: message.title || "提醒",
        message: message.body || message.message || "",
        timestamp,
        read: message.status === "read",
        link: message.link || null,
        data: {
          message_id: message.id,
          company_id: message.company_id,
          user_id: message.user_id,
          initiator_user_id: message.initiator_user_id,
          action_type: message.action_type,
          message_type: message.type,
        },
      };
    },
    mergeReminderNotification(notification, options = {}) {
      const { adjustTotalUnreadCount = true } = options;
      const next = [...this.recentNotifications];
      const existingIndex = next.findIndex(
        (item) => item.id === notification.id
      );
      const existingNotification =
        existingIndex !== -1 ? next[existingIndex] : null;

      if (existingIndex !== -1) {
        next[existingIndex] = {
          ...next[existingIndex],
          ...notification,
        };
      } else {
        next.push(notification);
      }

      next.sort((a, b) => {
        const aTime = new Date(a.timestamp || 0).getTime();
        const bTime = new Date(b.timestamp || 0).getTime();
        return bTime - aTime;
      });

      this.recentNotifications = next;

      if (adjustTotalUnreadCount) {
        if (!existingNotification && !notification.read) {
          this.totalUnreadReminderCount += 1;
          this.reminderPagination.totalItems += 1;
        } else if (
          existingNotification &&
          !existingNotification.read &&
          notification.read
        ) {
          this.totalUnreadReminderCount = Math.max(
            0,
            this.totalUnreadReminderCount - 1
          );
          this.reminderPagination.totalItems = Math.max(
            0,
            this.reminderPagination.totalItems - 1
          );
        }
      }
    },
    formatReminderTime(timestamp) {
      if (!timestamp) return "";
      const date = new Date(timestamp);
      if (Number.isNaN(date.getTime())) return "";
      return date.toLocaleString("zh-TW", {
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
      });
    },
    getReminderIcon(notification) {
      switch (notification.type) {
        case "reminder":
          return "fa fa-bell";
        case "alert":
          return "fa fa-exclamation-triangle";
        case "update":
          return "fa fa-sync-alt";
        default:
          return "fa fa-bell";
      }
    },
    getReminderColor(notification) {
      switch (notification.type) {
        case "reminder":
          return "warning";
        case "alert":
          return "error";
        case "update":
          return "success";
        default:
          return "primary";
      }
    },
    async openReminder(notification) {
      await this.markReminderAsRead(notification.id);

      if (this.userRole === "employee") {
        return;
      }

      const applicationMatch = notification.link?.match(
        /^\/applications\/(\d+)$/
      );
      console.log("notification.link ", notification.link);
      if (applicationMatch) {
        this.$router.push({
          path: "/pages/users/leave-management",
          query: {
            tab: "1",
            application_id: applicationMatch[1],
          },
        });
        return;
      }

      this.$router.push({
        path: "/pages/users/leave-management",
      });
    },
    async markReminderAsRead(notificationId) {
      const target = this.recentNotifications.find(
        (item) => item.id === notificationId
      );

      const wasUnread = Boolean(target && !target.read);

      if (wasUnread) {
        this.totalUnreadReminderCount = Math.max(
          0,
          this.totalUnreadReminderCount - 1
        );
        this.reminderPagination.totalItems = Math.max(
          0,
          this.reminderPagination.totalItems - 1
        );
      }

      this.recentNotifications = this.recentNotifications.map((item) =>
        item.id === notificationId ? { ...item, read: true } : item
      );

      try {
        await this.$axios.put(`/api/messages/${notificationId}`, {
          status: "read",
        });
        await this.$store.dispatch(
          "websocket/markNotificationAsRead",
          notificationId
        );
      } catch (error) {
        console.error("Failed to mark reminder as read:", error);

        if (wasUnread) {
          this.totalUnreadReminderCount += 1;
          this.reminderPagination.totalItems += 1;
        }

        this.recentNotifications = this.recentNotifications.map((item) =>
          item.id === notificationId ? { ...item, read: false } : item
        );
      }
    },
    async loadMoreUnreadNotifications() {
      if (
        !this.hasMoreUnreadReminders ||
        this.loadingUnreadNotifications ||
        this.markingAllUnreadNotifications
      ) {
        return;
      }

      const nextPage =
        this.reminderPagination.nextPage ||
        this.reminderPagination.currentPage + 1;
      await this.loadUnreadNotifications({ page: nextPage, reset: false });
    },
    async markAllUnreadNotificationsAsRead() {
      if (this.markingAllUnreadNotifications) {
        return;
      }

      this.markingAllUnreadNotifications = true;

      try {
        await this.$axios.put("/api/messages/unread/mark-all-read");
        this.resetReminderState();
        this.$store.dispatch("websocket/clearNotifications");
      } catch (error) {
        console.error("Failed to mark all unread reminders as read:", error);
      } finally {
        this.markingAllUnreadNotifications = false;
      }
    },
    clearReminderNotifications() {
      this.resetReminderState();
      this.loadingUnreadNotifications = false;
      this.$store.dispatch("websocket/clearNotifications");
    },
    drawerClose() {
      this.togglerActive = !this.togglerActive;
      this.$emit("drawer-toggle", true);
    },
    minifyDrawer() {
      this.togglerActive = !this.togglerActive;
      this.mini = !this.mini;
      const body = document.getElementsByTagName("body")[0];

      if (body.classList.contains("drawer-mini")) {
        body.classList.remove("drawer-mini");
      } else {
        body.classList.add("drawer-mini");
      }
    },
    // Initialize companies data
    async initializeCompanies() {
      // Check if companies array is empty
      // if (!this.companies || this.companies.length === 0) {
      // Fetch companies from API via Vuex
      await this.$store.dispatch("company/fetchCompaniesIDS");
      // }

      // Set default company after fetching
      // this.setDefaultCompany();
    },

    // Set default selected company based on user's company_id from Vuex
    setDefaultCompany() {
      if (this.companies && this.companies.length > 0) {
        // First priority: Use company_id from user Vuex store
        if (this.userCompanyId) {
          const userCompany = this.companies.find(
            (c) => c.id === parseInt(this.userCompanyId)
          );
          if (userCompany) {
            this.$store.dispatch("company/selectCompany", userCompany.id);
            return;
          }
        }

        // Second priority: Use saved company from localStorage
        const savedCompanyId = localStorage.getItem("selectedCompanyId");
        if (savedCompanyId) {
          const savedCompany = this.companies.find(
            (c) => c.id === parseInt(savedCompanyId)
          );
          if (savedCompany) {
            this.$store.dispatch("company/selectCompany", savedCompany.id);
            return;
          }
        }

        // Fallback: Use first company in the list
        this.$store.dispatch("company/selectCompany", this.companies[0].id);
      }
    },

    onCompanyChange(company) {
      if (company) {
        // Save selected company to Vuex store
        this.$store.dispatch("company/selectCompany", company.id);

        // Update user's company_id in Vuex if needed
        // Uncomment if you want to update the user's default company when they change it
        // this.$store.dispatch('user/updateCompanyId', company.id);

        // Emit event for other components to react
        this.$root.$emit("company-changed", company);

        // Refresh the current page or navigate if needed
        if (this.$route.name === "Users") {
          // If on users page, refresh the data
          this.$root.$emit("refresh-users-data");
        }
      }
    },

    // Handle user logout
    async logout() {
      this.showLogoutProgress = true;
      const startTime = Date.now();
      try {
        this.unregisterReminderHandler();
        this.clearReminderReconnect();
        await this.$store.dispatch("user/logout");
        this.clearReminderNotifications();

        // Ensure at least 300ms display
        const elapsed = Date.now() - startTime;
        if (elapsed < 500) {
          await new Promise((resolve) => setTimeout(resolve, 500 - elapsed));
        }

        // Redirect to login page after logout
        this.$router.push("/pages/authentication/login");
      } catch (error) {
        console.error("Error during logout:", error);
      } finally {
        this.showLogoutProgress = false;
      }
    },
  },
  beforeDestroy() {
    this.unregisterReminderHandler();
    this.clearReminderReconnect();
  },
};
</script>

<style scoped>
.notification-bell-wrapper {
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.notification-badge {
  position: absolute;
  top: -4px;
  right: -4px;
  min-width: 18px;
  height: 18px;
  padding: 0 5px;
  border: 2px solid #ffffff;
  border-radius: 9999px;
  background-color: #f5365c;
  color: #ffffff;
  font-size: 11px;
  font-weight: 700;
  line-height: 14px;
  text-align: center;
  pointer-events: none;
  z-index: 2;
}

.notification-bell-icon-shake {
  animation: notification-bell-shake 1.6s ease-in-out infinite;
  transform-origin: top center;
}

@keyframes notification-bell-shake {
  0%,
  100% {
    transform: rotate(0deg);
  }
  12% {
    transform: rotate(-8deg);
  }
  24% {
    transform: rotate(8deg);
  }
  36% {
    transform: rotate(-6deg);
  }
  48% {
    transform: rotate(6deg);
  }
  60% {
    transform: rotate(-4deg);
  }
  72% {
    transform: rotate(4deg);
  }
  84% {
    transform: rotate(-2deg);
  }
}
</style>
